function padBase64(b64: string): string {
  const pad = b64.length % 4
  if (pad === 0) return b64
  return b64 + '='.repeat(4 - pad)
}

export function base64UrlToUint8Array(b64url: string): Uint8Array {
  const b64 = padBase64(b64url.replace(/-/g, '+').replace(/_/g, '/'))
  const bin = atob(b64)
  const bytes = new Uint8Array(bin.length)
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i)
  return bytes
}

export function uint8ArrayToBase64(bytes: Uint8Array): string {
  let bin = ''
  for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i])
  return btoa(bin)
}

export function uint8ArrayToBase64Url(bytes: Uint8Array): string {
  return uint8ArrayToBase64(bytes).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '')
}

export function toCreationOptionsFromServer(server: any): PublicKeyCredentialCreationOptions {
  return {
    ...server,
    challenge: base64UrlToUint8Array(server.challenge),
    user: {
      ...server.user,
      id: base64UrlToUint8Array(server.user?.id)
    },
    excludeCredentials: Array.isArray(server.excludeCredentials)
      ? server.excludeCredentials.map((c: any) => ({
          ...c,
          id: base64UrlToUint8Array(c.id)
        }))
      : undefined
  }
}

export function serializeAttestationCredential(cred: PublicKeyCredential) {
  const response = cred.response as AuthenticatorAttestationResponse
  return {
    id: uint8ArrayToBase64Url(new Uint8Array(cred.rawId)),
    rawId: uint8ArrayToBase64(new Uint8Array(cred.rawId)),
    type: cred.type,
    response: {
      clientDataJSON: uint8ArrayToBase64Url(new Uint8Array(response.clientDataJSON)),
      attestationObject: uint8ArrayToBase64(new Uint8Array(response.attestationObject)),
      transports: (response as any).getTransports?.() ?? []
    }
  }
}
